
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Footer } from "@/components/Footer";
import { PageHeader } from "@/components/PageHeader";
import { EmailForm, EmailFormValues } from "@/components/auth/EmailForm";
import { CodeVerificationForm, CodeFormValues } from "@/components/auth/CodeVerificationForm";
import { LoginCard } from "@/components/auth/LoginCard";

const Login = () => {
  const { sendLoginCode, verifyLoginCode, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [step, setStep] = useState<"email" | "code">("email");
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  
  // Get the return URL from location state or default to '/assessment'
  const from = location.state?.from?.pathname || "/assessment";

  const handleEmailSubmit = async (values: EmailFormValues) => {
    setUserEmail(values.email);
    setUserName(values.fullName);
    
    const success = await sendLoginCode(values.email, values.fullName);
    if (success) {
      setStep("code");
    }
  };

  const handleCodeSubmit = async (values: CodeFormValues) => {
    console.log("Submitting code:", values.code);
    const success = await verifyLoginCode(userEmail, values.code);
    if (success) {
      navigate(from, { replace: true });
    } else {
      console.log("Code verification failed");
    }
  };

  const handleBackToEmail = () => {
    setStep("email");
  };

  const breadcrumbs = [
    { title: "Home", href: "/" },
    { title: "Login", href: "/login" },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Login to AIMAA"
        description="Access your assessments and start analyzing your AI maturity"
        breadcrumbs={breadcrumbs}
      />
      
      <div className="container mx-auto py-12 px-4">
        {step === "email" ? (
          <LoginCard
            title="Sign In"
            description="Enter your details to access your assessments"
          >
            <EmailForm onSubmit={handleEmailSubmit} isLoading={isLoading} />
          </LoginCard>
        ) : (
          <LoginCard
            title="Verify Your Email"
            description="Enter the 4-digit code sent to your email"
          >
            <CodeVerificationForm 
              onSubmit={handleCodeSubmit} 
              onBack={handleBackToEmail} 
              isLoading={isLoading} 
            />
          </LoginCard>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Login;
